module.exports = __webpack_public_path__ + "img/ic_toast_error.936f67d1.svg";